/**
 * author: Ananthapadmanabhan V K
 */
import { lazy, Suspense, useContext, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";
import CompanyList from "../CompanyList/CompanyList";
import InvitationList from "../InvitationList/InvitationList";
import Profile from "../Profile/Profile";
import SupplierCreate from "../SupplierCreate/SupplierCreate";
import SupplierList from "../SupplierList/SupplierList";
import "./SubAdminMain.scss";
import CompanyConnections from "../CompanyConnections/CompanyConnections";
import Dashboard from "../Dashboard/Dashboard";
import Header from "../Header/Header";
import RiskScore from "../RiskScore/RiskScore";

import MyProfile from "../MyProfile/MyProfile";
import RiskScoreInput from "../RiskScoreInput/RiskScoreInput";
import SupplierRiskScore from "../SupplierRiskScore/SupplierRiskScore";

import { SidebarContext, UserContext } from "../../../App";
import AIChatWidget from "../../../components/AI/AIChatWidget";
import { LS_AUTHORITY_KEY, LS_UI_ELEMENTS_CONFIG_KEY } from "../../../core/constants/common";
import DataViewReporting from "../../Common/Dataview/DataView";
import AssessmentSubmissionList from "../../Common/Forms/AssessmentList/AssessmentSubmissionList";
import FormList from "../../Common/Forms/FormList";
import FormSubmitted from "../../Common/Forms/FormSubmitted/FormSubmitted";
import Forms from "../../Common/Forms/Forms";
import CreateDataCollectionEvent from "../../Common/Forms/CreateDataCollectionEvent/CreateDataCollectionEvent";
import Sidebar from "../../Common/Sidebar/Sidebar";
import DataPoints from "../../Common/Standards/DataPoints/DataPoints";
import { default as AddMetric, default as Metric } from "../../Common/Standards/Metric/Metric";
import Standards from "../../Common/Standards/Standards";
import TopicsAdmin from "../../Common/Standards/TopicsAdmin/TopicsAdmin";
import TermsModal from "../../Common/Terms/TermsModal";
import UserForm from "../../Common/User/UserForm";
import UserList from "../../Common/User/UserList";
import LinkExpiryPage from "../../Expiry/LinkExpiryPage";
import InvalidRoutePage from "../../InvalidRoutePage/InvalidRoutePage";
import SupportPage from "../../Support/SupportPage";
import AlertList from "../AlertList/AlertList";
import Analytics from "../Analytics/Analytics";
import AnalyticsReport from "../AnalyticsReport/AnalyticsReport";
import CarbonEmissionDataContainer from "../CarbonEmission/CarbonEmissionDataContainer";
import CompanyDashboardOLD from "../CompanyDashboard/CompanyDashboardOLD";
import AIConfiguration from "../CompanySettings/AIConfiguration";
import CompanySettings from "../CompanySettings/CompanySettings";
import CountryRisk from "../CountryRisk/CountryRisk";
import CreateDocRule from "../CreateDocRule/CreateDocRule";
import DataPointsMetrics from "../DataPointsMetrics/DataPointsMetrics";
import DocumentRules from "../DocumentRules/DocumentRules";
import IndexDocument from "../Documents/index";
import EmailLog from "../../Common/EmailLog/EmailLog";
import IncidentActivity from "../IncidentActivityLog/IncidentActivityLog";
import IncidentList from "../IncidentList/IncidentList";
import IncidentReporting from "../IncidentReporting/IncidentReporting";
import PendingInvitations from "../PendingInvitations/PendingInvitations";
import ProfileSettings from "../ProfileSettings/ProfileSettings";
import RegulationReport from "../RegulationReport/RegulationReport";
import ReportingContainer from "../Reporting/ReportingContainer";
import ReportingList from "../Reporting/ReportingList";
import RiskAnalytics from "../RiskAnalytics/RiskAnalytics";
import SettingsTab from "../SettingsTab/SettingsTab";
import SupplierCompanyScore from "../SupplierCompanyScore/SupplierCompanyScore";
import SupplierImport from "../SupplierImport/SupplierImport";
import SupplierTasksList from "../SupplierTasksList/SupplierTasksList";
import SupplierTypeList from "../SupplierTypeList/SupplierTypeList";
import SupplyMaterialList from "../SupplyMaterialList/SupplyMaterialList";
// import img_GriSoftware from "../../../images/Gri_software.png"
// import img_GriContent from "../../../images/Gri_Content.png"

import { useNavigate } from "react-router-dom";
import CompareDataView from "../../Common/Dataview/CompareDataView/CompareDataView";
import Disclaimer from "../../Common/Disclaimer/Disclaimer";
import KPIList from "../../Common/KPI/KPIList";
import QualitativeQuestionsView from "../../Common/Standards/Questions/QualitativeQuestionsView";
import GeneralDisclosure from "../CompanySettings/GeneralDisclosure";
import MaterialTopic from "../CompanySettings/MaterialTopic";
import QualitativeTableSearchPage from "../CompanySettings/QualitativeTableSearchPage";

import ImportWizard from "../../../components/ImportWizard/ImportWizard";
import useHasPermission from "../../../core/hooks/useHasPermission";
import BRSRUpsale from "../../../upSale/BRSRUpsale";
import CSRDUpsale from "../../../upSale/CSRDUpsale";
import DoubleMaterialityUpsale from "../../../upSale/DoubleMaterialityUpsale";
import GHGEmissionsUpsale from "../../../upSale/GHGEmissionsUpsale";
import GRIUpsale from "../../../upSale/GRIUpsale";
import GolasKpisUpsale from "../../../upSale/GolasKpisUpsale";
import VSMEUpsale from "../../../upSale/VSMEUpsale";
import DataSourceConfiguration from "../../Common/Datasource/DataSourceConfiguration";
import DataSourceMapping from "../../Common/Datasource/DataSourceMapping";
import DataViewGrid from "../../Common/Dataview/DataViewGrid";
import DataViewGridGoalDetails from "../../Common/Dataview/DataViewGridGoalDetails";
import DataViewNew from "../../Common/Dataview/PeriodicDataView/DataViewNew";
import DoubleMatContainer from "../../Common/Forms/Materiality/DoubleMatContainer";
import FeatureFaq from "../../Faq/FeatureFaq";
import SuggestedFaq from "../../Faq/SuggestedFaq";
import EditDataCollection from "../../SuperAdmin/GHGEmissions/EditDataCollection";
import GHGEmissions from "../../SuperAdmin/GHGEmissions/GHGEmissions";
import ImportData from "../../SuperAdmin/ImportData/ImportData";
import ReportPage from "../CompanySettings/ReportPage";
import ESGAnalytics from "../ESGAnalytics/ESGAnalytics";
import AddGHGInventory from "../GHGEmissions/AddGHGInventory";
import GHGEmissionDataManagement from '../GHGEmissions/GHGEmissionDataManagement/GHGEmissionDataManagement';
import GHGEmissionsContainer from "../GHGEmissions/GHGEmissionsContainer";
import GHGInventory from "../GHGEmissions/GHGInventory";
import GHGOprBoundaries from "../GHGEmissions/GHGOprBoundaries";
import GHGOrgBoundaries from "../GHGEmissions/GHGOrgBoundaries";
import GHGReport from "../GHGEmissions/GHGReport";
import GHGSettings from "../GHGEmissions/GHGSettings";
import GHGOprIdentify from "../GHGEmissions/IdentifyEmissionSource";
import GHGOprReview from "../GHGEmissions/ReviewAndFinalize";
import AddUAEFDLInventory from "../UAEFDL/AddUAEFDLInventory";
import UAEFDLDataManagement from '../UAEFDL/UAEFDLDataManagement/UAEFDLDataManagement';
import UAEFDLContainer from "../UAEFDL/UAEFDLContainer";
import UAEFDLInventory from "../UAEFDL/UAEFDLInventory";
import UAEFDLReport from "../UAEFDL/UAEFDLReport";
import HomePage from "../HomePage/HomePage";
import NewDashboard from '../NewDashboard';
import ESRSContainer from "../Reporting/ESRS/ESRSContainer";
import GHGContainer from "../Reporting/GHG/GHGContainer";
import UomContainer from "../../SuperAdmin/Uom/UomContainer";
import UomVersionManagement from "../../SuperAdmin/Uom/UomVersionManagement";
import AnomalyContainer from "../AnomalyDetection/AnomalyContainer";
// First lazy-loaded route module in the app — chunk is only fetched on first navigation into /goals_kpi/*.
const GoalsAndKpiContainer = lazy(() => import("../GoalsAndKpi/GoalsAndKpiContainer"));

const SubAdminMain = ({ t }) => {
  const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));

  const { sidebarDisplay } = useContext(SidebarContext);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const uiElementsConfig = JSON.parse(localStorage.getItem(LS_UI_ELEMENTS_CONFIG_KEY)) ?? null;
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);
  const { hasChatWithDataViewPermission } = useHasPermission();

  const navigateToDis = () => {
    navigate(`/company_admin/disclaimer`, {
    });

  };
  useEffect(() => {
    if (uiElementsConfig?.texts?.appTitle) {
      // Updates browser tab title
      document.title = uiElementsConfig?.texts?.appTitle;
    }
    // Function to check if the screen width is less than 780px
    const handleResize = () => {
      setIsSmallScreen(window.matchMedia('(max-width: 780px)').matches);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Check initial screen size
    handleResize();

    // Remove event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  const currentYear = new Date().getFullYear();

  return (
    <div>
      <Header></Header>
      <Sidebar />
      <div
        className={`page_wrapper ${sidebarDisplay ? '' : 'page_wraper_width'} ${isSmallScreen ? 'page_wraper_width' : ''}${
          window.location.pathname === '/company_admin/BRSR' ? ' brsr-page-loading' : ''
        }`}
      >
        <Routes>
          <Route
            path="/"
            exact={true}
            element={<Navigate replace to="/company_admin/home" />}
          />
          <Route path="/dashboard" element={<NewDashboard />} />
          <Route path="/dashboard_old" element={<Dashboard />} />
          <Route path="/dashboard/goal/:goalId" element={<Dashboard />} />
          <Route path="/list_invitations" element={<InvitationList />} />
          <Route path="/company_list" element={<CompanyList />} />
          <Route path="/list_supplier" element={<SupplierList />} />
          <Route path="/clients" element={<CompanyConnections />} />
          <Route path="/supplier_profile/:profile_id" element={<Profile />} />
          <Route path="/create_supplier" element={<SupplierCreate />} />
          <Route path="/risk_score" element={<RiskScore />} />
          <Route path="/edit_supplier" element={<SupplierCreate />} />
          <Route path="/configurations/" element={<SettingsTab />}>
          </Route>
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/risk_input" element={<RiskScoreInput />} />
          <Route path="/risk_input/:paramObj" element={<RiskScoreInput />} />
          <Route path="/risk_supplier_list" element={<SupplierRiskScore />} />
          <Route path="files" element={<IndexDocument />} />
          <Route path="supplier_type" element={<SupplierTypeList />} />
          <Route path="supply_materials" element={<SupplyMaterialList />} />
          <Route path="country_score" element={<SupplierCompanyScore />} />
          <Route path="/not_found" element={<InvalidRoutePage />} />
          <Route path="/documents" element={<IndexDocument />} />
          <Route path="/assessments" element={<Forms />} />
          <Route path="/assessments/create_dce" element={<CreateDataCollectionEvent />} />
          <Route path="/assessments/update_dce/:id" element={<CreateDataCollectionEvent />} />
          <Route path="/assessments_submit_list" element={<FormSubmitted />} />
          <Route path="/reports_download" element={<RegulationReport />} />
          <Route path="/pending_invitations" element={<PendingInvitations />} />
          <Route path="/profile_settings" element={<ProfileSettings />} />
          <Route path="/alerts" element={<AlertList />} />
          <Route path="/import_supplier" element={<SupplierImport />} />
          <Route path="/document_rules/:reg_id" element={<DocumentRules />} />
          <Route path="/document_rules_create/:reg_id" element={<CreateDocRule />} />
          <Route path="/document_rules_edit/:reg_id/:rule_id" element={<CreateDocRule />} />
          <Route path="/country_risk" element={<CountryRisk />} />
          <Route path="/tasks" element={<SupplierTasksList />} />
          <Route path="/incident/:paramObj" element={<IncidentActivity />} />
          <Route path="/incident_list" element={<IncidentList />} />
          <Route path="/report_incident" element={<IncidentReporting />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/user_form" element={<UserForm />} />
          <Route path="/standard" element={<Standards />} />
          <Route path="/metric/:std_id/:topic_id" element={<AddMetric />} />
          <Route path="/substandard_input/:std_id/:metric_id/:date" element={<DataPointsMetrics />} />
          <Route path="/reporting_list" element={<ReportingList />} />
          <Route path="/reporting" element={<ReportingContainer />} />
          <Route path="/topiclist/:std_id" element={<TopicsAdmin />} />
          <Route path="/metriclist/:std_id/:topic_id" element={<Metric />} />
          <Route path="/datapointlist/:std_id/:topic_id/:metric_id" element={<DataPoints />} />
          <Route path="*" element={<Navigate replace to="/company_admin/not_found" />} />
          <Route path="/risk_analytics_list" element={<RiskAnalytics />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/analytics_report/:metric_id/:date" element={<AnalyticsReport />} />
          <Route path="/analytics_report/:metric_id/:date/:energyKey" element={<AnalyticsReport />} />
          <Route path="/company_settings" element={<CompanySettings />} />
          <Route path="/forms" element={<FormList />} />
          <Route path="/unit_wise" element={<ESGAnalytics />} />
          <Route path="/dataview" element={<DataViewNew key="dataview" />} />
          <Route path="/assessments/:id/submissions/:self" element={<AssessmentSubmissionList />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/PageExpiry" element={<LinkExpiryPage />} />
          <Route path="/analytics_report/type/:type_id" element={<AnalyticsReport />} />
          <Route path="/dashboard_old_cmp" element={<div className="Dashboard"><CompanyDashboardOLD /></div>} />
          <Route path="/emission" element={<CarbonEmissionDataContainer />} />
          <Route path="/ESGAI" element={<AIConfiguration />} />
          <Route path="/Report" element={<ReportPage />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/qualitative" element={<MaterialTopic />} />
          <Route path="/qualitative_table_search" element={<QualitativeTableSearchPage />} />
          <Route path="/generaldisc" element={<GeneralDisclosure />} />
          <Route path="/kpilist" element={<KPIList />} />
          <Route path="/compare" element={<CompareDataView />} />
          <Route path="/qualquestions/:std_id/:topic_id/:metric_id" element={<QualitativeQuestionsView />} />
          <Route path="/kpidataview/goal/:goalId" element={<DataViewReporting key="kpidataview" type={'KPI'} />} />

          <Route path="/import_Data" element={<ImportData />} />
          <Route path="/import_wizard" element={<ImportWizard />} />
          <Route path="/ghg_emissions" element={<GHGEmissions />} />
          <Route path="/editGHGData" element={<EditDataCollection />} />
          <Route path="/ghg-report" element={<GHGContainer />} />
          <Route path="/ghg_org_boundaries" element={<GHGOrgBoundaries />} />
          <Route path="/ghg_inventory" element={<GHGInventory />} />
          <Route path="/ghg_opr_boundaries" element={<GHGOprBoundaries />} />
          <Route path="/ghg_opr_identify" element={<GHGOprIdentify />} />
          <Route path="/ghg_opr_review" element={<GHGOprReview />} />
          <Route path="/add_ghg_inventory" element={<AddGHGInventory />} />
          <Route path="/collect_data" element={<GHGEmissionDataManagement />} />
          <Route path="/ghg_inventory_report" element={<GHGReport />} />
          <Route path="/ghg_inventory_settings" element={<GHGSettings />} />

          <Route path="/uaefdl_inventory" element={<UAEFDLInventory />} />
          <Route path="/add_uaefdl_inventory" element={<AddUAEFDLInventory />} />
          <Route path="/uaefdl_collect_data" element={<UAEFDLDataManagement />} />
          <Route path="/uaefdl_inventory_report" element={<UAEFDLReport />} />
          <Route
            path="/uaefdl/*"
            element={<UAEFDLContainer />}
          />

          <Route path="/statusview" element={<DataViewGrid />} />
          <Route path="/kpistatusview/goal/:goalId" element={<DataViewGridGoalDetails />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/Faq" element={<SuggestedFaq />} />
          <Route path="/FeatureFaq" element={<FeatureFaq />} />
          <Route path="/ESRS" element={<ESRSContainer />} />
          <Route
            path="/dmat/*"
            element={<DoubleMatContainer />}
          />
          <Route
            path="/ghg/*"
            element={<GHGEmissionsContainer />}
          />
          <Route path="/dsmaps" element={<DataSourceMapping />} />
          <Route path="/dsconfig" element={<DataSourceConfiguration />} />
          <Route path="/golas-kpis-upsale" element={<GolasKpisUpsale/>} />
          <Route path="/double-materiality-upsale" element={<DoubleMaterialityUpsale/>} />
          <Route path="/ghg-emissions-upsale" element={<GHGEmissionsUpsale/>} />
          <Route path="/gri-upsale" element={<GRIUpsale/>} />
          <Route path="/brsr-upsale" element={<BRSRUpsale/>} />
          <Route path="/csrd-upsale" element={<CSRDUpsale/>} />
          <Route path="/vsme-upsale" element={<VSMEUpsale/>} />
          <Route path="/ghg-upsale" element={<GRIUpsale/>} />
          <Route path="/uom" element={<UomContainer />} />
          <Route path="/uom/versions" element={<UomVersionManagement />} />
          <Route path="/anomalies/*" element={<AnomalyContainer />} />
          <Route
            path="/goals_kpi/*"
            element={
              <Suspense fallback={<Spinner animation="border" size="sm" />}>
                <GoalsAndKpiContainer />
              </Suspense>
            }
          />
          <Route path="/email_log" element={<EmailLog />} />
        </Routes>
      </div>
      <div className="footer">

        <div className="Privacy_termsbox">
          <ul>
            <li>
              {uiElementsConfig?.texts?.footer ?? `©${currentYear} ${t("EcodrisilAllRightsReserved.label")}`}
            </li>
            <li>
              <a className="" target="_blank" href={uiElementsConfig?.texts?.privacyPolicy ?? "https://ecodrisil.com/privacy-policy"}>
                {t("privacyPolicy.label")}
              </a>
            </li>
            <li>
              <a className="" target="_blank" href={uiElementsConfig?.texts?.termsAndConditions ?? "https://ecodrisil.com/terms-of-use"}>
                {t("TermsConditions.label")}
              </a>
            </li>
            <li onClick={() => navigateToDis()}>
              <a className="cursor" target="_blank">
                {t("Disclaimers.label")}
              </a>
            </li>
          </ul>
        </div>
        <div className="footer_right">
          {/* <ul>
            <li>
              <img src={img_GriSoftware} data-tip="SOFTWARE AND TOOLS PARTNER" />
              <ReactTooltip />
            </li>
            <li>
              <img src={img_GriContent} data-tip="CONTENT USED WITH PERMISSION" />
              <ReactTooltip />
            </li>
            <li></li>
          </ul> */}
          <div>{t("Version.label")} 2.0</div>
        </div>
      </div>
      <TermsModal />
      {hasChatWithDataViewPermission && <AIChatWidget />}  
    </div>
  );
};

export default withTranslation()(SubAdminMain);
